import SiteHeader from '@/pages/home/components/SiteHeader';
import Hero from '@/pages/home/components/Hero';
import QuickStart from '@/pages/home/components/QuickStart';
import NewsTimeline from '@/pages/home/components/NewsTimeline';
import Tutorials from '@/pages/home/components/Tutorials';
import PlayGuide from '@/pages/home/components/PlayGuide';
import SettingsTips from '@/pages/home/components/SettingsTips';
import FaqSection from '@/pages/home/components/FaqSection';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#FBF9F4] text-stone-900">
      <SiteHeader />
      <main>
        <Hero />
        <QuickStart />
        <NewsTimeline />
        <Tutorials />
        <PlayGuide />
        <SettingsTips />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}